import { useState, useEffect } from "react"
import { Input } from "@shared/components/ui/input"
import { Button } from "@shared/components/ui/button"
import { FilterButton } from "./FilterButton"
import { useFilterToggle } from "../hooks/useFilterToggle"
import type { FilterConfig } from "@shared/types/filters"

interface SearchFilterProps {
  value?: string | null
  onChange?: (value: string | null) => void
  filterConfig: FilterConfig
}

export function SearchFilter({ value, onChange, filterConfig }: SearchFilterProps) {
  const { isOpen, setIsOpen, close } = useFilterToggle()
  const [inputValue, setInputValue] = useState(value || "")

  useEffect(() => {
    if (isOpen) {
      setInputValue(value || "")
    }
  }, [isOpen, value])

  const handleApply = () => {
    onChange?.(inputValue.trim() || null)
    close()
  }

  const handleClear = () => {
    setInputValue("")
    onChange?.(null)
  }

  const isActive = !!value
  const displayValue = {
    label: filterConfig.label,
    displayValue: value ? `"${value}"` : "",
  }

  return (
    <FilterButton
      filter={filterConfig}
      isActive={isActive}
      isOpen={isOpen}
      displayValue={displayValue}
      onToggle={setIsOpen}
      onClear={handleClear}
    >
      <div className="p-3 space-y-3 min-w-[220px] select-none">
        <span className="text-sm font-medium">{filterConfig.label}</span>
        <Input
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder={filterConfig.placeholder || `Search ${filterConfig.label.toLowerCase()}...`}
          className="h-8 select-text"
          onKeyDown={(e) => e.key === "Enter" && handleApply()}
          autoFocus
        />
        <div className="border-t border-border pt-2">
          <Button
            onClick={handleApply}
            size="sm"
            className="w-full h-8"
            disabled={!inputValue.trim()}
          >
            Apply
          </Button>
        </div>
      </div>
    </FilterButton>
  )
}
